<div class="test-email-dialog">
    <!-- Dialog Header -->
    <div class="dialog-header">
        <div class="header-left">
            <mat-icon class="header-icon">send</mat-icon>
            <div class="header-text">
                <h2>Send Test Email</h2>
                <span class="template-badge">{{ data.templateName }}</span>
            </div>
        </div>
        <button class="btn-close" (click)="dialogRef.close()" matTooltip="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <form [formGroup]="testForm" class="dialog-body">
        <!-- No valid languages warning -->
        <div class="warning-banner" *ngIf="!hasAnyValidLanguage">
            <mat-icon>warning</mat-icon>
            <span>No valid content available. Please add content and fix any validation errors first.</span>
        </div>

        <!-- Recipient Email -->
        <div class="form-section">
            <label class="section-label">
                <mat-icon>alternate_email</mat-icon>
                Recipient Email
            </label>
            <mat-form-field appearance="outline" class="full-width">
                <input matInput formControlName="email" placeholder="email@example.com" type="email">
                <mat-error *ngIf="testForm.get('email')?.hasError('required')">
                    Email is required
                </mat-error>
                <mat-error *ngIf="testForm.get('email')?.hasError('email')">
                    Invalid email address
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Language Selection -->
        <div class="form-section">
            <label class="section-label">
                <mat-icon>language</mat-icon>
                Select Language
            </label>
            <div class="language-grid">
                <button
                    type="button"
                    class="lang-chip"
                    *ngFor="let lang of languages"
                    [class.active]="selectedLangCode === lang.languageCode"
                    [class.available]="lang.isValid"
                    [class.unavailable]="!lang.isValid"
                    [disabled]="!lang.isValid"
                    [matTooltip]="getLanguageTooltip(lang)"
                    matTooltipPosition="above"
                    (click)="selectLanguage(lang.languageCode)">
                    {{ lang.languageCode.toUpperCase() }}
                    <mat-icon class="chip-icon" *ngIf="lang.isValid && selectedLangCode === lang.languageCode">check</mat-icon>
                </button>
            </div>
        </div>

        <!-- Template Variables -->
        <div class="form-section" *ngIf="templateVariables.length > 0">
            <label class="section-label">
                <mat-icon>data_object</mat-icon>
                Template Variables
                <span class="badge">{{ templateVariables.length }}</span>
            </label>
            <div formArrayName="variables" class="variables-container">
                <div *ngFor="let varControl of variablesArray.controls; let i = index"
                     [formGroupName]="i" class="variable-item">
                    <span class="var-label">{{ varControl.get('name')?.value }}</span>
                    <mat-form-field appearance="outline" class="var-field">
                        <input matInput formControlName="value" placeholder="Value..."
                            [attr.dir]="isRtlLanguage(selectedLangCode) ? 'rtl' : null">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </form>

    <!-- Dialog Footer -->
    <div class="dialog-footer">
        <button type="button" class="btn-secondary" (click)="dialogRef.close()">
            <mat-icon>close</mat-icon>
            Cancel
        </button>
        <button type="button" class="btn-primary"
                [disabled]="testForm.invalid || sendingEmail || !hasAnyValidLanguage"
                (click)="sendTestEmail()">
            <mat-spinner *ngIf="sendingEmail" diameter="18"></mat-spinner>
            <mat-icon *ngIf="!sendingEmail">send</mat-icon>
            {{ sendingEmail ? 'Sending...' : 'Send Test Email' }}
        </button>
    </div>
</div>
